import { Pipe, PipeTransform } from '@angular/core';
import { Shop } from '@services/shops/shop.model';
import { ITrackingPage } from '@pdqdev/pdq-shared/dist/interfaces/shopPlugin/ITrackingPage';

@Pipe({
  name: 'hexToRgb',
  standalone: false,
})
export class HexToRgbPipe implements PipeTransform {
  constructor() {}
  transform(hex: string, opacity: number = 1): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
}

@Pipe({
  name: 'themeEditorUrl',
  standalone: false,
})
export class ThemeEditorUrlPipe implements PipeTransform {
  constructor() {}
  transform(shop: Shop): string {
    if (shop) {
      return `https://${shop.name}/admin/themes/current/editor`;
    }
    return '';
  }
}

@Pipe({
  name: 'missingPrivacyMFA',
  standalone: false,
})
export class MissingPrivacyMFA implements PipeTransform {
  constructor() {}
  transform(settings: {
    searchPage: {
      verifyByTrackingOrOrderNumber: boolean;
      verificationStrategy: ITrackingPage.VerificationStrategy;
    };
  }): boolean {
    return settings?.searchPage?.verificationStrategy === 'none';
  }
}
